import { Heading, Input, InputProps, Text } from "@ttc3k/trekker";
import { Flex } from "styled-system/jsx";
import { useOnboardingContext } from "onboarding/OnboardingContext.tsx";

interface InviteScreenProps {
  title?: string;
  description: string;
  inputProps?: InputProps;
}

export const InviteScreen = ({
  title,
  description,
  inputProps,
}: InviteScreenProps) => {
  const { emailAddress } = useOnboardingContext();
  return (
    <>
      <Flex
        flexDir={"column"}
        gap={"150"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        {title && <Heading size={"h4"}>{title}</Heading>}
        <Text color={"text.mid"} textAlign={"center"}>
          {description}
        </Text>
      </Flex>
      <Input value={emailAddress} type="email" {...inputProps} />
    </>
  );
};
